import { render, staticRenderFns } from "./addThroughTransportDisposition.vue?vue&type=template&id=224a6f1a&scoped=true&"
import script from "./addThroughTransportDisposition.vue?vue&type=script&lang=js&"
export * from "./addThroughTransportDisposition.vue?vue&type=script&lang=js&"
import style0 from "./addThroughTransportDisposition.vue?vue&type=style&index=0&id=224a6f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224a6f1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224a6f1a')) {
      api.createRecord('224a6f1a', component.options)
    } else {
      api.reload('224a6f1a', component.options)
    }
    module.hot.accept("./addThroughTransportDisposition.vue?vue&type=template&id=224a6f1a&scoped=true&", function () {
      api.rerender('224a6f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/throughTransport/components/addThroughTransportDisposition.vue"
export default component.exports